import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Suspense, lazy, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { detectDefaultLang, langFromPathname } from './lib/lang';

const CnLanding = lazy(() => import('./pages/cn/Landing'));
const CnAbout = lazy(() => import('./pages/cn/About'));
const CnContact = lazy(() => import('./pages/cn/Contact'));
const CnPrivacy = lazy(() => import('./pages/cn/Privacy'));
const CnTerms = lazy(() => import('./pages/cn/Terms'));
const EnLanding = lazy(() => import('./pages/en/Landing'));
const EnAbout = lazy(() => import('./pages/en/About'));
const EnContact = lazy(() => import('./pages/en/Contact'));
const EnPrivacy = lazy(() => import('./pages/en/Privacy'));
const EnTerms = lazy(() => import('./pages/en/Terms'));
const NotFound = lazy(() => import('./pages/NotFound'));

function LangSync() {
  const location = useLocation();
  const { i18n } = useTranslation();
  useEffect(() => {
    const lang = langFromPathname(location.pathname);
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [location.pathname, i18n]);
  return null;
}

export default function App() {
  const defaultLang = detectDefaultLang();
  return (
    <>
      <LangSync />
      <Suspense fallback={<div className="p-6 text-white/60">Loading...</div>}>
        <Routes>
          <Route path="/" element={<Navigate to={`/${defaultLang}`} replace />} />
          <Route path="/cn" element={<CnLanding />} />
          <Route path="/cn/about" element={<CnAbout />} />
          <Route path="/cn/contact" element={<CnContact />} />
          <Route path="/cn/privacy" element={<CnPrivacy />} />
          <Route path="/cn/terms" element={<CnTerms />} />
          <Route path="/en" element={<EnLanding />} />
          <Route path="/en/about" element={<EnAbout />} />
          <Route path="/en/contact" element={<EnContact />} />
          <Route path="/en/privacy" element={<EnPrivacy />} />
          <Route path="/en/terms" element={<EnTerms />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
}
